import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(() => {
    // Start with 2 hours from first visit, persist in sessionStorage
    const stored = sessionStorage.getItem('piano-countdown-end');
    if (stored) {
      const diff = Math.max(0, Math.floor((parseInt(stored) - Date.now()) / 1000));
      return diff;
    }
    const endTime = Date.now() + 2 * 60 * 60 * 1000; // 2 hours
    sessionStorage.setItem('piano-countdown-end', endTime.toString());
    return 2 * 60 * 60;
  });
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="bg-navy text-white py-2 px-4 text-center text-sm font-medium flex items-center justify-center gap-2" data-id="element-217">
      <Clock className="w-4 h-4 text-gold" data-id="element-218" />
      <span className="text-white/80" data-id="element-219">Oferta termina en</span>
      <span className="font-mono font-bold text-gold tracking-wider" data-id="element-220">
        {pad(hours)}:{pad(minutes)}:{pad(seconds)}
      </span>
    </div>;
}